import React, { useId } from "react";

const COLORS = ["var(--rosa)", "var(--marigold)", "var(--agua)", "#bf5769", "#e0bd87"];
const FLAG_PITCH = 72;
// Wide enough for a 4K window (a multiple of the 720 px string curve): "slice" crops the sides instead of scaling,
// so the flags keep their size at any width.
const GARLAND_WIDTH = 4320;
const FLAG_COUNT = Math.ceil(GARLAND_WIDTH / FLAG_PITCH);
const STRING_PATH = `M0 5Q360 22 720 5${Array.from({ length: GARLAND_WIDTH / 720 - 1 }, (_, i) => `T${(i + 2) * 720} 5`).join("")}`;

/** Cut-paper garland from the main design, with scalloped edges and sugar-skull cutouts. */
const PapelPicado = () => {
  const id = useId();
  return (
    <div className="picado-wrap" aria-hidden="true">
      {/* y from -4: the string and the raised flags reach -3.5, the lowered flags end at 71. */}
      <svg className="picado" viewBox={`0 -4 ${GARLAND_WIDTH} 76`} preserveAspectRatio="xMidYMin slice" fill="none">
        <defs>
          <mask id={id}>
            <path d="M5 5h54v45l-5 7-6-3-5 9-11-5-11 5-5-9-6 3-5-7z" fill="white" />
            <g fill="black">
              <path d="M32 13c-9 0-14 6-14 13 0 5 3 8 6 10v7h16v-7c3-2 6-5 6-10 0-7-5-13-14-13z" />
              <circle cx="12" cy="12" r="2" /><circle cx="52" cy="12" r="2" />
              <circle cx="12" cy="25" r="2" /><circle cx="52" cy="25" r="2" />
              <circle cx="12" cy="39" r="2" /><circle cx="52" cy="39" r="2" />
              <path d="m24 49 8 5 8-5-8 11z" />
            </g>
            <g fill="white">
              <circle cx="26" cy="26" r="3.5" /><circle cx="38" cy="26" r="3.5" />
              <path d="m32 31-2 4h4zM27 39h2v5h-2zm8 0h2v5h-2z" />
            </g>
          </mask>
        </defs>
        <path d={STRING_PATH} stroke="var(--marigold)" strokeOpacity=".4" />
        {Array.from({ length: FLAG_COUNT }, (_, i) => (
          <g key={i} transform={`translate(${i * FLAG_PITCH + 4} ${Math.sin(i * Math.PI / 10) * 8})`}>
            {/* The inner path, not the positioned <g>, carries the intro's flag drop (styles/intro.css). */}
            <path
              className="picado-flag"
              style={{ "--from-center": Math.abs(i - FLAG_COUNT / 2) }}
              d="M5 5h54v58H5z"
              fill={COLORS[i % COLORS.length]}
              mask={`url(#${id})`}
            />
          </g>
        ))}
      </svg>
    </div>
  );
};

export default PapelPicado;
